// eslint-disable-next-line id-blacklist
export function copyTokenToClipboard(content: any): boolean {
  // TODO update to https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
  const tempInput = document.createElement('input')
  // eslint-disable-next-line id-blacklist
  tempInput.value = content
  document.body.append(tempInput)
  tempInput.select()
  document.execCommand('copy')
  tempInput.remove()
  return true
}
